import { useIsE2E } from '../useIsE2E';
import { useIsFastenEnabled } from './useIsFastenEnabled';

/**
 * Fasten vs legacy 1up for the profile connect tab. Cypress web E2E still runs
 * oneUpHealthConnect against add-portal / portal-search-input; new profiles default
 * isFastenEnabled=true, so we use the legacy path whenever Cypress is active.
 */
export const usePortalConnectUsesFastenFlow = (medicalProfileId: string) => {
    const { isFastenEnabled, isLoading } = useIsFastenEnabled(medicalProfileId);
    const isE2E = useIsE2E();
    return {
        showFastenConnectUi: isFastenEnabled && !isE2E,
        isLoading,
    };
};
